<template>
  <div>
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'AdminBase',
  }
</script>

<style scoped>

</style>
